// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"39d934be","239":"b8d2525a","455":"0190abee"}[chunkId] + ".chunk.js";
};